import { createIcon } from '@chakra-ui/react';

export const ChevronRightIcon = createIcon({
  displayName: 'ChevronRightIcon',
  viewBox: '0 0 32 32',
  path: (
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.4393 26.0816C9.85355 25.5237 9.85355 24.6192 10.4393 24.0613L18.3787 16.5L10.4393 8.93872C9.85355 8.38083 9.85355 7.47631 10.4393 6.91842C11.0251 6.36053 11.9749 6.36053 12.5607 6.91842L21.5607 15.4898C22.1464 16.0477 22.1464 16.9523 21.5607 17.5102L12.5607 26.0816C11.9749 26.6395 11.0251 26.6395 10.4393 26.0816Z'
      fill='currentColor'
    />
  ),
});
